import _ from "@lodash";
import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";
import clsx from "clsx";
import React from "react";
import EmpresaPessoaApp from "../EmpresaPessoa/EmpresaPessoaApp";
import EmpresaPessoaProntuarioDialog from "./EmpresaPessoaProntuarioDialog";

class EmpresaPessoaProntuarioApp extends XAPPComponent {

    state = {
        open: null
    };

    openProntuario = (_AValue) => {
        this.setState(_.set({ ...this.state }, "open", _AValue));
    };

    render() {
        const { showListagem = true, children = null, className = "", data = {}, idpessoaformulario = null, readOnly = false } = this.props;
        var { xappRouteParams } = this.props;
        var { open } = this.state;
        if (_.isUndefined(xappRouteParams) || _.isNull(xappRouteParams)) {
            xappRouteParams = this.props.match.params;
        }
        return (
            <React.Fragment>
                {showListagem &&
                    <EmpresaPessoaApp
                        id="EmpresaPessoaProntuario"
                        xappRouteParams={xappRouteParams}
                        openProntuario={this.openProntuario}
                        label="Prontuários"
                        target="spvwempresapessoapaciente"
                        {...this.props}
                        defaultTipo={[3]}
                    />
                }
                {!_.isNull(children) && !_.isNull(idpessoaformulario) &&
                    <div
                        className={clsx("w-fit cursor-pointer", className)}
                        onClick={() => this.openProntuario({ ...data, idpessoaformulario })}
                    >
                        {children}
                    </div>
                }
                <EmpresaPessoaProntuarioDialog
                    open={open}
                    openProntuario={this.openProntuario}
                    xappRouteParams={xappRouteParams}
                    readOnly={readOnly}
                />
            </React.Fragment>
        );
    }
}


export default EmpresaPessoaProntuarioApp;
